import { Component, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { BaseComponent } from '@shared-components/base-component';
import { UrlHelper } from '@shared-helpers/urlHelper';
import { AlternateLanguageModel } from '@shared-model/configuration/AlternateLanguageModel';

@Component({
  selector: 'fourd-top-navigation',
  templateUrl: './top-navigation.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class TopNavigationComponent extends BaseComponent implements OnInit {
  configurationsLoaded: boolean = false;

  alternateLanguages: AlternateLanguageModel[] = null;
  alternatePageLinks: Element[] = null;

  constructor() {
    super("TopNavigationComponent")

    this.subscriptionTracker?.add(this.memberLoggedInObservable?.subscribe((memberLoggedIn) => {
      if (memberLoggedIn == true) {
        // Member login state has just changed to logged in
        // Check that logged in JS script has been loaded
        this.ensureExternalScriptLoaded(
          UrlHelper.externalScriptLoggedInJs,
          //(scriptPath: string, event: Event) => { console.log(`Success loading '${scriptPath}' from Angular 1`); }, // Success callback
          //(scriptPath: string, event: Event) => { console.log(`Error loading '${scriptPath}' from Angular 1`); } // Error callback
          null, null
        );
      }
    }));
  }

  ngOnInit() {
    this.ensureConfigLoaded(() => {
      this.alternateLanguages = this.config()?.AlternateLanguages;
      this.configurationsLoaded = true;
      this.ensureMemberLoaded(() => {

      });
    });

    this.alternatePageLinks = Array.from(document.querySelectorAll('link[rel="alternate"]'));
  }

  isLanguageActive(language: AlternateLanguageModel):boolean {
    return language?.Language?.toLowerCase() === this.config()?.Culture?.toLowerCase();
  }

  pageUrlForLanguage(language: AlternateLanguageModel): string {
    let lang: Element = this.alternatePageLinks?.find(l => l?.attributes?.getNamedItem("hreflang")?.value?.toLowerCase() === language?.Language?.toLowerCase());
    if (lang) {
      // Link found in header, return URL
      return lang?.attributes?.getNamedItem("href")?.value;
    }
    else {
      // No link found in header, return root domain
      return "http" + (!language?.DomainSupportsHttps ? "" : "s") + "://" + language?.Domain + "/";
    }
  }

}
